import e from"react";import r from"../../../external/classnames/index.js";const a=({children:a,className:s=""})=>{const t=r("card",s);return e.createElement("div",{className:t},a)};export{a as Card};
//# sourceMappingURL=Card.js.map
